import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useUnderlineHidden } from 'kineticUtils';

const useSearchStyles = makeStyles(({ spacing, palette }) => {
  const underline = useUnderlineHidden();
  return createStyles({
    ...underline,
    input: {
      paddingTop: spacing(2),
      paddingLeft: spacing(2),
    },
    searchIcon: {
      color: palette.mode === 'dark' ? `${palette.common.white} !important` : 'inherit',
    },
  });
});

export default useSearchStyles;
